/**
 * Estado TEMPORÁRIO (só no browser, sessionStorage) do "Seleccionar todas" da
 * tela de vacunação: quais vacinas foram marcadas por essa ação (o "delta") e
 * se o toggle está ativo. NÃO vai para o Firebase — as vacinas em si são
 * gravadas normalmente em childCase.vaccines. Limpo ao concluir/cancelar o caso
 * (ChildCaseService.cancelCaseRegistry).
 */
export interface VaccinationBulkDraft {
    selectedVaccines?: string[]; // vacinas marcadas no momento (todas, não só o delta)
    bulkActive?: boolean;
    bulkAdded?: string[];
}

export class VaccinationDraftUtil {
    private static readonly PREFIX = 'nm-vaccination-bulk:';

    private static key(token: string): string {
        return VaccinationDraftUtil.PREFIX + (token || 'anon');
    }

    static save(token: string, draft: VaccinationBulkDraft): void {
        try {
            sessionStorage.setItem(VaccinationDraftUtil.key(token), JSON.stringify(draft));
        } catch {
        }
    }

    static load(token: string): VaccinationBulkDraft | null {
        try {
            const raw = sessionStorage.getItem(VaccinationDraftUtil.key(token));
            return raw ? JSON.parse(raw) as VaccinationBulkDraft : null;
        } catch {
            return null;
        }
    }

    static clear(token: string): void {
        try {
            sessionStorage.removeItem(VaccinationDraftUtil.key(token));
        } catch {
        }
    }
}
